function getLanguages(widgetSettings) {
  if (!widgetSettings) {
    return [];
  }
  return Object.keys(widgetSettings).filter(key => key.startsWith('multilingual_')).map(key => key.split('_')[1]);
}
export function hasMultilingualKeys(widgetSettings) {
  if (!widgetSettings) {
    return false;
  }
  return Object.keys(widgetSettings).some(key => key.startsWith('multilingual_'));
}
function getMultilingualKeys(widgetSettings) {
  const languages = getLanguages(widgetSettings);
  const multiligualKeys = {};
  languages.forEach(lang => {
    Object.keys(widgetSettings[`multilingual_${lang}`]).forEach(translationKey => {
      const translationValue = widgetSettings[`multilingual_${lang}`][translationKey];
      multiligualKeys[`${translationKey}▶︎l:${lang}`] = translationValue;
    });
  });
  return multiligualKeys;
}
export function addMultilingualKeysFromAppSettings(publicData, widgetSettings) {
  if (!widgetSettings) {
    return publicData;
  }
  const multilingualKeys = getMultilingualKeys(widgetSettings);
  publicData.COMPONENT = {
    ...publicData.COMPONENT,
    ...multilingualKeys
  };
  return publicData;
}
//# sourceMappingURL=addMultilingualKeysFromAppSettings.js.map